import { isValidCalendarDisplay } from './Calendar';
export const calendarDisplayApiToCalendarDisplay = calendarDisplay => {
  if (!calendarDisplay) {
    throw new Error('undefined calendarDisplayApi', {
      cause: {
        calendarDisplay
      }
    });
  }
  if (isValidCalendarDisplay(calendarDisplay)) {
    return calendarDisplay;
  }
  throw new Error('Invalid calendarDisplayApi', {
    cause: {
      calendarDisplay
    }
  });
};
//# sourceMappingURL=converters.js.map